"use client";

import { useSkuLocationBalancesQuery } from "../api/queries";
import { hasShopFeature } from "../lib/has-shop-feature";
import type { ShopFeatureFlags } from "@/modules/merchant/domain/contracts/shop-feature-flags";

type Props = {
  shopId: string;
  branchId: string;
  shopProductSkuId: string;
  featureFlags: ShopFeatureFlags | null | undefined;
};

/** แสดงตำแหน่งช่องแรกตาม FIFO (zone sort → code) ใต้ชื่อสินค้าใน cart */
export function PosCartLocationHint({
  shopId,
  branchId,
  shopProductSkuId,
  featureFlags,
}: Props) {
  const enabled =
    hasShopFeature(featureFlags, "warehouse_locations") &&
    branchId.length > 0;

  const q = useSkuLocationBalancesQuery(
    shopId,
    enabled ? branchId : undefined,
    enabled ? shopProductSkuId : undefined,
  );

  if (!enabled || q.isLoading || !q.data) return null;

  const top = q.data.locations[0];
  if (top) {
    return (
      <p className="mt-1 font-medium text-secondary text-xs">
        ຕຳແໜ່ງ: {top.locationCode}
        {q.data.locations.length > 1
          ? ` (+${q.data.locations.length - 1})`
          : ""}
      </p>
    );
  }

  if (q.data.unlocatedQty > 0 && q.data.onHand > 0) {
    return (
      <p className="mt-1 text-amber-700 text-xs dark:text-amber-400">
        ຍັງບໍ່ຈັດຊ່ອງ ({q.data.unlocatedQty})
      </p>
    );
  }

  return null;
}
